import { useCallback, useContext } from 'react';
import { ChatContextType } from '@trinity/chat';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { useActiveBrandIdentifierNullSafe } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier';
import { useHeaderContext } from '../context';

type Params = {
  onClick?: () => unknown;
};

export const useSetGlobalChatContext = (params?: Params) => {
  const dispatch = useContext(ChatStateDispatchContext);
  const { setPendingContext, setPendingContextType } = useHeaderContext();
  const brandIdentifier = useActiveBrandIdentifierNullSafe();

  return useCallback(() => {
    dispatch({
      type: 'instance-context-changed',
      payload: {
        context: {
          type: ChatContextType.Global,
        },
        brandIdentifier,
      },
    });
    setPendingContextType(null);
    setPendingContext(null);
    params?.onClick?.();
  }, [
    brandIdentifier,
    dispatch,
    params,
    setPendingContextType,
    setPendingContext,
  ]);
};
